
<div #coverimgdiv class="cg-theme-background " data-html2canvas-ignore [ngStyle]="{'background-image': 'url(' + photo + ')','border':'+ bordershadow +'}"></div>
<router-outlet></router-outlet>
